import { CloseIcon, ArrowBackIcon } from 'components/icons';
import useOnClickOutside from 'hooks/useOnClickOutside';
import React from 'react';
import styles from './drawer.module.scss';
export default function Drawer({
  drawerActive,
  setDrawerActive,
  children,
  title,
  onGoback,
  backIcon,
  close,
}) {
  const clickOutRef = React.useRef();
  useOnClickOutside(clickOutRef, () => setDrawerActive(false));

  const handleClose = () => {
    if (close) {
      close();
      return;
    }
    setDrawerActive(false);
  };
  return (
    <>
      <div
        className={`${styles.drawer} ${drawerActive ? styles.active : ''}`}
        ref={clickOutRef}
      >
        <div className={styles.header}>
          {backIcon && (
            <button className={styles.close} type="button" onClick={onGoback}>
              <ArrowBackIcon />
            </button>
          )}
          <h1 className={styles.title}>{title}</h1>
          <button
            className={styles.close}
            type="button"
            onClick={() => handleClose()}
          >
            <CloseIcon />
          </button>
        </div>
        <div className={styles.container}>{children}</div>
      </div>
      <div
        className={`${styles.drawerbg} ${drawerActive ? styles.active : ''}`}
      ></div>
    </>
  );
}

const DrawerBody = ({ children }) => {
  return <div className={styles.body}>{children}</div>;
};

export const DrawerFooter = ({ children }) => {
  return <div className={styles.footer}>{children}</div>;
};

Drawer.DrawerFooter = DrawerFooter;
Drawer.DrawerBody = DrawerBody;
